<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <h1> {{ user.fullname }} </h1>
        <h3>{{ user.email }}</h3>
        <h1> 
          {{ $t('prices') }} 
          <v-btn color="primary" outline @click="goTo('users', { userFiltersStore: true })"> {{ $t('back') }} </v-btn>
        </h1>
      </v-flex>

      <v-flex xs12 v-for="carrier in carriers" :key="carrier.id">
        <v-card>
          <v-card-title>
            <h3> {{ carrier.name }} </h3>
          </v-card-title>

          <v-data-table class="elevation-1"
                        :items="carrierServices(carrier)"
                        hide-headers
                        hide-actions
                        :no-data-text="$t('noDataAvailable')">
            <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
            <template v-slot:items="props">
              <td> {{ props.item.name }} </td>
              <td class="pa-0 pr-2 text-xs-right">

                <v-btn color="primary" flat icon @click="goTo('editUserPrice', { userId: $route.params.userId, serviceId: props.item.id })">
                  <font-awesome-icon icon="edit"></font-awesome-icon>
                </v-btn>

              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import User from '@/client/user'
import Carrier from '@/client/carrier'
import Service from '@/client/service'

export default {
  name: 'UserPricesView',

  props: {},

  data () {
    return {
      user: {},
      carriers: [],
      services: []
    }
  },

  components: {
  },

  computed: {
  },

  methods: {
    carrierServices (carrier) {
      return this.services.filter(o => o.carrier_id === carrier.id)
    },
  },

  watch: {
  },

  async mounted () {
    this.user = await User.findOne(this.$route.params.userId)
    this.carriers = await Carrier.all({ per_page: 2000 })
    this.services = await Service.all({ per_page: 2000 })
  }
}
</script>
